import { render } from "./TextComponentEditor.vue?vue&type=template&id=7ce0c315&ts=true"
import script from "./TextComponentEditor.vue?vue&type=script&lang=ts"
export * from "./TextComponentEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__